import React from "react";

import Banner from "./components/Banner";
import Comeceagora from "./components/ComeceAgora";
import OndeUsar from "./components/OndeUsar";
import NascemosParaFacilitar from "./components/NascemosParaFacilitar";
import TagVeloe from "./components/TagVeloe";
import Planos from "./components/Planos";
import { useFetchContent } from "src/hooks/useContentful/useFetchContent";
import Loading from "src/components/Loading";
import { ApolloProvider } from "@apollo/client";
import { client } from "src/services/apollo";
import MotivosPraUsar from "./components/MotivosPraUsar";
import RecargaAutomatica from "./components/RecargaAutomatica";

function Parcerias() {
  const { data, isLoading } = useFetchContent();

  if (isLoading || !data) return <Loading />;

  return (
    <ApolloProvider client={client}>
      <Banner />
      <Planos />
      <RecargaAutomatica />
      {/* <NascemosParaFacilitar /> */}
      {/* <MotivosPraUsar /> */}
      <Comeceagora />
      {/* <OndeUsar /> */}
      <TagVeloe />
    </ApolloProvider>
  );
}

export default Parcerias;
